import { CartFormData } from "./types/formTypes"

import Toastify from "toastify-js"
/**
 * Sends a POST request to add an item to the cart.
 * @param formData - The form data to send.
 * @returns The server's response.
 */
async function addToCart(formData: CartFormData) {
    return sendRequest('cart/add.js', formData);
}

/**
 * Sends a POST request to update an item in the cart.
 * @param formData - The form data to send.
 * @returns The server's response.
 */
async function updateItemCart(formData: Object) {
    return sendRequest('cart/change.js', formData);
}

/**
 * Sends a POST request to remove an item from the cart.
 * @param formData - The form data to send.
 * @returns The server's response.
 */
async function removeFromCart(formData: Object) {
    return sendRequest('cart/change.js', formData);
}

/**
 * Sends a POST request to the specified endpoint.
 * @param endpoint - The Shopify cart endpoint.
 * @param formData - The form data to send.
 * @returns The server's response data.
 */
async function sendRequest(endpoint: string, formData: Object | FormData) {
    try {
        const response = await fetch(`${window.Shopify.routes.root}${endpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });

        if (!response.ok) {

            const error = await response.json();
            Toastify({

                text: error.message,

                duration: 3000,
                style: {
                    background: "linear-gradient(to right, #2d2926, #2d2926)",
                },

            }).showToast();
            throw new Error(`Failed to communicate with the server: ${response.statusText}`);
        }
        console.info('Response:', response);
        return await response.json();
    } catch (error) {
        console.error('Error:', error);

    }
}

export default { addToCart, updateItemCart, removeFromCart };